/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_No_Filter_ResultsInputs */

const en_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const de_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const fr_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const es_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const it_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const nl_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const pl_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const fi_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const da_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

const sv_story_bank_no_filter_results = /** @type {(inputs: Story_Bank_No_Filter_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No stories match your filter`)
};

/**
* | output |
* | --- |
* | "No stories match your filter" |
*
* @param {Story_Bank_No_Filter_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_no_filter_results = /** @type {((inputs?: Story_Bank_No_Filter_ResultsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_No_Filter_ResultsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_no_filter_results(inputs)
	if (locale === "fr") return fr_story_bank_no_filter_results(inputs)
	if (locale === "es") return es_story_bank_no_filter_results(inputs)
	if (locale === "it") return it_story_bank_no_filter_results(inputs)
	if (locale === "nl") return nl_story_bank_no_filter_results(inputs)
	if (locale === "pl") return pl_story_bank_no_filter_results(inputs)
	if (locale === "fi") return fi_story_bank_no_filter_results(inputs)
	if (locale === "da") return da_story_bank_no_filter_results(inputs)
	if (locale === "sv") return sv_story_bank_no_filter_results(inputs)
	return en_story_bank_no_filter_results(inputs)
});